//
//
//
//

export default {
  props: [

  ],
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {

  },
  components: {

  }
}



// WEBPACK FOOTER //
// ./src/pages/user/Interaction.vue